// src/components/Footer.js
import React from 'react';
import { useTranslation } from "react-i18next";


const Footer = () => {
  return (
    <footer className="bg-gray-0 text-gray-300 py-[2vmin] text-center">
      <LanguageSwitcher />
      <div className='h-[3vmin]'></div>
      <p>&copy; {new Date().getFullYear()} SecurityCode. All rights reserved.</p>
      <div className='h-[3vmin]'></div>
    </footer>
  );
};

export default Footer;



const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  return (
    <div className="flex justify-center space-x-4 mt-4">
      <button
        className={`px-4 py-2 font-bold ${
          i18n.language === "es" ? "text-green-400" : "text-gray-300"
        }`}
        onClick={() => changeLanguage("es")}
      >
        Español
      </button>
      <button
        className={`px-4 py-2 font-bold ${
          i18n.language === "en" ? "text-green-400" : "text-gray-300"
        }`}
        onClick={() => changeLanguage("en")}
      >
        English
      </button>
      <button
        className={`px-4 py-2 font-bold ${
          i18n.language === "fr" ? "text-green-400" : "text-gray-300"
        }`}
        onClick={() => changeLanguage("fr")}
      >
        Français
      </button>
    </div>
  );
};